import React, { useEffect, useState } from 'react';
import css from './ThisIsSocialbnb.module.css';
import { FormattedMessage } from 'react-intl';
import { Link, useParams } from 'react-router-dom';

const smallScreenImageEN = 'https://res.cloudinary.com/dlcacck3a/image/upload/v1769083017/socialbnb/containers/OldSTLandingPage/sections/ThisIsSocialbnb/images/small-screen-en.webp';





const smallScreenImageDE = 'https://res.cloudinary.com/dlcacck3a/image/upload/v1769083016/socialbnb/containers/OldSTLandingPage/sections/ThisIsSocialbnb/images/small-screen-de.webp';

const largeScreenImageEN = 'https://res.cloudinary.com/dlcacck3a/image/upload/v1769083016/socialbnb/containers/OldSTLandingPage/sections/ThisIsSocialbnb/images/large-screen-en.webp';

const largeScreenImageDE = 'https://res.cloudinary.com/dlcacck3a/image/upload/v1769083014/socialbnb/containers/OldSTLandingPage/sections/ThisIsSocialbnb/images/large-screen-de.webp';

const ThisIsSocialbnb = () => {
  const { lang } = useParams();
  const [image, setImage] = useState(largeScreenImageEN);

  useEffect(() => {
    const updateImage = () => {
      const isLargeScreen = window.innerWidth >= 768;
      if (isLargeScreen) {
        setImage(lang === 'de' ? largeScreenImageDE : largeScreenImageEN);
      } else {
        setImage(lang === 'de' ? smallScreenImageDE : smallScreenImageEN);
      }
    };

    updateImage();
    window.addEventListener('resize', updateImage);

    return () => {
      window.removeEventListener('resize', updateImage);
    };
  }, [lang]);

  return (
    <div className={css.container}>
      <h2 className={`${css.title} pl-2`}>
        <FormattedMessage id="landing.what.is.socialbnb.title" />
      </h2>

      <div className={css.imageContainer}>
        <img alt="thisissocialbnb-image" src={image} className={css.responsiveImage} />
      </div>
    </div>
  );
};

export default ThisIsSocialbnb;
